<template>
  <div class="text-sm">
    <TabGroup :selected-index="selectedTabIndex" vertical @change="onTabChange">
      <TabList class="flex flex-col">
        <TabEl v-for="tab in tabs" :key="tab.id" v-slot="{ selected }" as="template">
          <button
            class="group border-l-4 py-2 focus:outline-none"
            :data-intercom-target="`EditorConfigTab-${tab.id}`"
            :class="[selected ? 'border-neutral-60 bg-neutral-95' : 'border-transparent']"
          >
            <div class="ml-6 flex items-center space-x-3">
              <component
                :is="tab.icon"
                class="h-6 w-6"
                :class="[selected ? 'text-neutral-20' : 'text-neutral-40 group-hover:text-neutral-20']"
                aria-hidden="true"
              />
              <span
                class="font-medium"
                :class="[selected ? 'text-neutral-20' : 'text-neutral-40 group-hover:text-neutral-20']"
                >{{ tab.name }}</span
              >
            </div>
          </button>
        </TabEl>
      </TabList>
    </TabGroup>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
//Components
import { TabGroup, TabList, Tab as TabEl } from "@headlessui/vue";

//Type
import type { Component } from "vue";
export interface Tab<idType = number | string> {
  id: idType;
  name: string;
  icon: Component;
}

export type Tabs<idType = number | string> = Array<Tab<idType>>;

//Props
const props = withDefaults(
  defineProps<{
    tabs: Tabs;
    selectedTab: Tab;
  }>(),
  {
    tabs: () => [],
  },
);

//Emits
const emit = defineEmits<{
  (e: "update:selectedTab", tab: Tab): void;
}>();

const onTabChange = (index) => {
  const tab = props.tabs[index];
  emit("update:selectedTab", tab);
};

//State
const selectedTabIndex = computed(() => props.tabs.findIndex((tab) => tab.id === props.selectedTab.id));
</script>
